import '../css/home.css';
import CustomCard from '../components/CustomCard';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useDispatch, useSelector } from 'react-redux';
import { fetchLatestProducts, fetchProducts } from '../store/action';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSearchParams } from "react-router-dom";

function HomePage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { products, productsLatest } = useSelector((state) => state.productReducer);
  const { isLoading } = useSelector((state) => state.globalReducer);

  useEffect(() => {
    dispatch(fetchProducts(searchParams.get('cat')));
    dispatch(fetchLatestProducts());
  }, []);

  useEffect(() => {
    dispatch(fetchProducts(searchParams.get('cat')));
    dispatch(fetchLatestProducts());
  }, [searchParams]);

  const changePage = (page) => {
    navigate(page);
  }

  return (
    <section id="homePage">
      <div className="container">
        <div className="text-center">
          <h1 style={{ fontFamily: 'Bebas Neue', fontWeight: '900', fontSize: '65px', letterSpacing: '2.5px' }}>HEARDWOOD HEAT</h1>
          <p className="mb-4">Tap in to see Luka Dončić break down the Luka 1 'Legend of 7' colorway on the latest Hardwood Heat.</p>
        </div>
        <div className="big-image" style={{ height: '575px', width: '100%' }}>
          {
            isLoading ?
              <Skeleton style={{ height: '100%', width: '100%' }} />
              :
              <img style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center' }} src="https://static.nike.com/a/images/f_auto/dpr_1.0,cs_srgb/w_1253,c_limit/938a31b5-e403-4db1-93d8-5dcfd786b68f/nike-just-do-it.jpg" />
          }
        </div>
        <h1 style={{ fontFamily: 'Bebas Neue', fontWeight: '900', fontSize: '45px', marginTop: '50px', letterSpacing: '0.5px' }}>Our Products</h1>
        <div className="custom-grid-container">
          {
            products.length ? products.map(product => {
              return (
                <CustomCard load={isLoading} product={product} detail={true} key={'product-home-' + product.id} changePage={changePage} />
              )
            })
              :
              <></>
          }
        </div>
        {
          !products.length && <div style={{ fontFamily: 'Bebas Neue', fontSize: '24px', textAlign: 'center' }}>No product found</div>
        }
      </div>
      {
        productsLatest.length && (
          <div id="latestProduct">
            <div className="container">
              <h1 style={{ fontFamily: 'Bebas Neue', fontWeight: '900', fontSize: '45px', marginTop: '50px', letterSpacing: '0.5px' }}>NEW ARRIVALS</h1>
              <div className="custom-grid-container custom-slider">
                {
                  productsLatest.length ? productsLatest.map(product => {
                    return (
                      <CustomCard load={isLoading} product={product} detail={true} key={'product-home-' + product.id} changePage={changePage} />
                    )
                  })
                    :
                    <></>
                }
              </div>
            </div>
          </div>
        )
      }
    </section>
  );
}

export default HomePage;
